import { useContext, useEffect, useState } from "react";
import SiteService from "../../../services/SiteService";
import { Link } from "react-router-dom";
import siteService from "../../../services/SiteService";
import CategoryInImage from "../../../components/frontpage/CategoryInImage";
import SiteContext from "../../../store/siteContext";
import FavouriteButton from "../../../components/ui/functional/FavouriteButton";

export default function FavoritesSection({ maxArticleAmount, maxPerRow = 3 }) {
	const [favouriteArticles, setFavouriteArticles] = useState([]);
	const [isLoading, setIsLoading] = useState(false);

	const categories = useContext(SiteContext).categories;

	useEffect(() => {
		if (!categories || categories.length === 0) return;
		setIsLoading(true);
		fetch(`${SiteService.apiPath}/user/articlefavourites`, {
			method: "GET",
		})
			.then((response) => response.json())
			.then((data) => {
				setIsLoading(false);

				if (!data || data.success === false || !Array.isArray(data)) {
					return;
				}

				data.forEach((article) => {
					if (!article.category && article.categories?.length > 0) {
						const match = categories.find(cat => cat._id === article.categories[0]);
						if (match) {
							article.category = match.name;
						}
					}
				});

				//sort data by date
				data.sort((a, b) => new Date(b.date) - new Date(a.date));

				setFavouriteArticles(data);
			})
			.catch(err => {
				console.error("Failed to fetch favourites:", err);
				setIsLoading(false);
			});
	}, [categories]);

	function FavouriteArticle({ favorite }) {
		const shareUrl = `${siteService.path}/artikkel/${favorite.urlString}`;
		return (
			<Link
				to={`/artikkel/${favorite.urlString}`}
				key={favorite.id}
				className="no-underline bg-white border rounded-lg overflow-hidden flex flex-col h-full shadow-md transition transform duration-300 hover:shadow-lg hover:-translate-y-1 hover:scale-105"
			>
				<div className="w-full h-40 bg-gray-200 relative border rounded-lg">
					<CategoryInImage part={favorite} />
					<img
						src={`${SiteService.apiPath}/image/articles/${favorite._id}/header-medium.webp`}
						alt={favorite.name}
						className="w-full h-full object-cover rounded-lg"
					/>
				</div>
				<div className="p-4 flex-grow hover:underline">
					<h4 className="font-semibold mb-2">{favorite.name}</h4>
				</div>
				<div className="px-4 pb-4 flex justify-between items-center mt-auto">
					<span className="text-xs text-gray-500">
						{new Date(favorite.date).toLocaleDateString('no-NO', {
							day: 'numeric',
							month: 'long',
							year: 'numeric',
						})}
					</span>
					<div className="flex items-center space-x-2">
						<FavouriteButton
							style={{
								background: '#fffaec',
								border: '2px solid lightgray',
								borderRadius: '90px',
								padding: '2px',
							}}
							articleId={favorite._id}
							addText={false}
							stroke="white"
							iconHeight="1.3em"
							iconWidth="1.3em"
						/>
					</div>
				</div>
			</Link>
		);
	}

	// Tailwind grid class based on maxPerRow
	const gridColsClass = `grid-cols-1 sm:grid-cols-3 md:grid-cols-${maxPerRow}`;

	return (
		<div className="bg-white rounded-lg shadow-md p-6">
			<div className="flex justify-between items-center mb-6">
				<h3 className="text-xl font-semibold text-primary">Mine favoritter</h3>
				<Link to="/min-side/favoritter" className="text-sm text-black-50 hover:underline">Se alle</Link>
			</div>

			{favouriteArticles.length > 0 ? (
				<div className={`grid gap-4 ${gridColsClass}`}>
					{favouriteArticles.slice(0, maxArticleAmount).map((article, i) => (
						<FavouriteArticle favorite={article} key={i} />
					))}
				</div>
			) : (
				<div className="text-center py-8">
					<i className="far fa-heart text-gray-300 text-4xl mb-2"></i>
					<p className="text-gray-500">Du har ingen favoritter ennå.</p>
					<p className="text-sm text-gray-400 mt-1">Utforsk artikler og marker dem som favoritter.</p>
				</div>
			)}
		</div>
	);
}
